export default "__VITE_PUBLIC_ASSET__c63733cd__"